import { Link, NavLink, useNavigate } from "react-router-dom";
import { Shield, Menu, X } from "lucide-react";
import { useState } from "react";

const links = [
    { to: "/browse", label: "Browse" },
    { to: "/submit", label: "Submit" },
    { to: "/about", label: "About" },
];

export default function Header() {
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    return (
        <header
            data-testid="site-header"
            className="sticky top-0 z-50 backdrop-blur-xl bg-[#050608]/85 border-b border-white/10"
        >
            <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
                <button
                    data-testid="logo-home-link"
                    onClick={() => navigate("/")}
                    className="flex items-center gap-3 group"
                >
                    <div className="relative w-9 h-9 border border-volt flex items-center justify-center hud-brackets">
                        <Shield className="w-4 h-4 text-volt" />
                    </div>
                    <div className="text-left">
                        <div className="font-oswald font-bold text-lg tracking-widest uppercase leading-none">
                            SIX<span className="text-volt">CLICK</span>
                        </div>
                        <div className="mono-label text-[9px] leading-tight">Military · Intel · Discounts</div>
                    </div>
                </button>

                <nav className="hidden md:flex items-center gap-1">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            data-testid={`nav-${l.to.replace("/", "")}-link`}
                            className={({ isActive }) =>
                                `px-4 py-2 font-oswald uppercase tracking-wider text-sm border border-transparent transition-colors ${
                                    isActive
                                        ? "text-volt border-volt/60"
                                        : "text-[#94a3b8] hover:text-white hover:border-white/20"
                                }`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                    <Link
                        to="/browse"
                        data-testid="header-cta-scan"
                        className="btn-volt ml-2 text-xs"
                    >
                        Scan Sector
                    </Link>
                </nav>

                <button
                    data-testid="mobile-menu-toggle"
                    onClick={() => setOpen(!open)}
                    className="md:hidden p-2 border border-white/10 text-volt"
                >
                    {open ? <X size={18} /> : <Menu size={18} />}
                </button>
            </div>

            {open && (
                <div className="md:hidden border-t border-white/10 bg-[#050608]">
                    <div className="flex flex-col p-4 gap-1">
                        {links.map((l) => (
                            <NavLink
                                key={l.to}
                                to={l.to}
                                onClick={() => setOpen(false)}
                                data-testid={`mobile-nav-${l.to.replace("/", "")}`}
                                className={({ isActive }) =>
                                    `px-4 py-3 font-oswald uppercase tracking-wider text-sm border ${
                                        isActive
                                            ? "text-volt border-volt/60"
                                            : "text-[#94a3b8] border-white/10"
                                    }`
                                }
                            >
                                {l.label}
                            </NavLink>
                        ))}
                    </div>
                </div>
            )}
        </header>
    );
}
